import ko = require('knockout');
import $ = require('jquery');
import perfLoggerService from "Services/PerfLoggerService";

var ViewModelTemplateLoader = {
    loadComponent: function (name, componentConfig, callback) {
        if (typeof componentConfig.template === 'string' &&
            typeof componentConfig.viewModel === 'function') {
            var vm = componentConfig.viewModel;
            var template = $.parseHTML(componentConfig.template) || [];

            callback({
                template: template,
                createViewModel: (params, componentInfo) => new vm(params, componentInfo)
            });
        }
        else
            callback(null);
    },

    loadViewModel: function (name, componentConfig, callback) {
        callback(function (params, componentInfo) {
			var constructedVm = new componentConfig.default(params, componentInfo);
            return constructedVm;
        });
    }
}

ko.components.loaders.unshift(ViewModelTemplateLoader);